<template>
  <modal class="modal" name="page-delete" :height="'auto'" :width="'375'" @before-open="beforeOpen">
    <h1 class="modal-heading">Delete Page</h1>
    <h2 class="modal-subheading">Are you sure you want to delete this page? This will permanently delete the page and all the content. There is no recovering this page.</h2>
    <ff-button
      data-test="page-delete-cancel"
      :text="'Cancel'"
      :pattern="2"
      :action="cancel"
    />
    <ff-button
      data-test="page-delete-confirm"
      :text="'Delete'"
      :pattern="3"
      :action="deletePage"
    />
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import analytics from '../../mixins/analytics'
import persist from '../../mixins/persist'
import FFButton from '../DesignSystem/FFButton'

export default {
  name: 'ConfirmDelete',
  mixins: [
    analytics,
    persist
  ],
  components: {
    'ff-button': FFButton
  },
  props: {
  },
  data () {
    return {
      channel_id: null,
      page_id: null,
      callback: null
    }
  },
  computed: {
    ...mapState(['channel', 'user'])
  },
  methods: {
    beforeOpen (event) {
      this.channel_id = event.params.channel_id
      this.page_id = event.params.page_id
      this.page = event.params.page
      this.callback = event.params.callback
    },
    deletePage () {
      if (!this.channel_id || !this.page_id) return
      this.PagesDelete(this.channel_id, this.page_id, () => {
        // page was deleted
        this.track('[Fanfolk] Deleted Page')
        this.$store.dispatch('fetchChannel')
        if (!this.callback) return
        return this.callback()
      })
    },
    cancel () {
      this.$store.commit('PAGE_DELETED')
      this.$modal.hide('page-delete')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";
  ::v-deep
  .vm--modal {
    padding: $unit-3;
    box-sizing: border-box;
    border-radius: $borderRadius;
  }
</style>
